import cn from 'classnames';

import { Loading } from '../../Loading';
import { Alert } from '../../atoms/Alert';
import { IconLicense, IconTrashCan } from '@/components/icons';

export interface ImageListItemProps {
	testId?: string;
	id: string;
	name: string;
	removeInput: (id: string) => void;
	inProgress?: boolean;
	className?: string;
	error?: string | null;
}

const ImageListItem = (props: ImageListItemProps) => {
	const {
		testId = 'ImageListItem',
		removeInput,
		name,
		id,
		inProgress = false,
		className = '',
		error = null,
	} = props;

	function handleClick() {
		removeInput(id);
	}

	return (
		<>
			<div
				data-testid={testId}
				className={cn(
					'flex min-w-0 gap-4 rounded-xl bg-slate-100 p-4',
					className,
				)}
			>
				{inProgress && (
					<div className="relative grid w-5 place-items-center pr-2">
						<Loading />
					</div>
				)}
				<span className="grid place-items-center">
					<IconLicense className="inline-block h-5 w-5" />
				</span>
				<span
					className="relative inline-block flex-1 overflow-hidden text-ellipsis whitespace-nowrap
						text-base font-normal"
				>
					{name}
				</span>
				<button onClick={handleClick}>
					<IconTrashCan className="h-6 w-6 fill-black lg:h-7 lg:w-7" />
				</button>
			</div>
			<Alert type="danger">{error}</Alert>
		</>
	);
};

export default ImageListItem;
